
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mapn1qF5eYeiKnCnPKhpNGSZiuogbmLi_hWh1Khyv1MhxEMeta } from "/app/apps/frontend/src/pages/map.vue?macro=true";
import { default as carttUMmtksq2wv_45QRB7bds5YpdvAShj5taYBbdLRHU_45vsEMeta } from "/app/apps/frontend/src/pages/cart.vue?macro=true";
import { default as menuQdy9BrYl7P5xwX0YbARGK_45jNoJrQ2A8yoEBAChGCRl4Meta } from "/app/apps/frontend/src/pages/menu.vue?macro=true";
import { default as abouteN_n_ImgL9s9ry7JGwbEXWy_7prkd40FO49cE_45MlNxQMeta } from "/app/apps/frontend/src/pages/about.vue?macro=true";
import { default as indexX5RGxEUWJpcWvV6_457QRlnhA20v28DfbgH8N7CcI7lL0Meta } from "/app/apps/frontend/src/pages/index.vue?macro=true";
import { default as contactiFyp2ILpY_45Hc08YpKYorcMiKUHkz6jCPDodN2ttZMxwMeta } from "/app/apps/frontend/src/pages/contact.vue?macro=true";
import { default as gallery2BI63m50GmwQZ5dxYPPmriZ08i2ww_45s6UdNw2JzKiYwMeta } from "/app/apps/frontend/src/pages/gallery.vue?macro=true";
import { default as reviews_Yh9n3XNcjvF02syUs4GFRAy3sU3LFxjUglIcG7_GWEMeta } from "/app/apps/frontend/src/pages/reviews.vue?macro=true";
import { default as loginvWOTq9B41qLizNvXFXJM2IIpJKAEc_zBQ3omUtKRl0wMeta } from "/app/apps/frontend/src/pages/auth/login.vue?macro=true";
import { default as indexaB4vPfpiZWIjhVPsZ_oY2T7FIXkDKKe8Q5JeJnDGphIMeta } from "/app/apps/frontend/src/pages/posts/index.vue?macro=true";
import { default as _91slug_930_uG6kn_45_451QnAyGMi_45IwozrLWISoLaq79aBswunNVFoMeta } from "/app/apps/frontend/src/pages/tags/[slug].vue?macro=true";
import { default as order_45refund3DX9lfUdkDic87PG2X3aqW1nY1lUFNsHpETxevb149MMeta } from "/app/apps/frontend/src/pages/order-refund.vue?macro=true";
import { default as order_45ticket8_edUw_45_xstMRFnsUE6GGgiUYnB91mz0CvhRfwdXyJIMeta } from "/app/apps/frontend/src/pages/order-ticket.vue?macro=true";
import { default as _91slug_93I1csEqzDIeqWSj1I9RARX__Rl444wNPqaug54MIALoQMeta } from "/app/apps/frontend/src/pages/posts/[slug].vue?macro=true";
import { default as test_45sessionyKbkPsUsnDpykQouAFh_qW6GliU0JMlOd_45_454v11TrKEMeta } from "/app/apps/frontend/src/pages/test-session.vue?macro=true";
import { default as registerLKye_WId_LmWOpbjuuKwZm6fkZhhuZ9B6Ys86c2R0v8Meta } from "/app/apps/frontend/src/pages/auth/register.vue?macro=true";
import { default as indexc7uOu6zZq3xirPceIgHzgkFrtSkfzzLEZ_2xaYkRObEMeta } from "/app/apps/frontend/src/pages/tickets/index.vue?macro=true";
import { default as indexJm6Jil0pgziG9RTipsjWD3NOymqaj6Z9hxwjt4VFYCsMeta } from "/app/apps/frontend/src/pages/checkout/index.vue?macro=true";
import { default as indexNKnoxnN0dwRFKLl_2KWz0JMKcrrPgYVpr0LB83VEowkMeta } from "/app/apps/frontend/src/pages/products/index.vue?macro=true";
import { default as index4EqZTS9I4aKnvikjK9CIv7Yi1BHIwqL8HsOKSuV0m5YMeta } from "/app/apps/frontend/src/pages/services/index.vue?macro=true";
import { default as ticket_45pricingdvsxAe6Koqxua8uqXTB9tmXSi5GbsNMsA9gcD4oVExsMeta } from "/app/apps/frontend/src/pages/ticket-pricing.vue?macro=true";
import { default as _91slug_93MAjsfTWQfNZyMxqLPYxwtJFJCDaukJzGfIbp58cLcgQMeta } from "/app/apps/frontend/src/pages/tickets/[slug].vue?macro=true";
import { default as cancelYUNNJTTGYJSLQDgrHQeGxomN0i_jwHNuH9hIo2GtnEAMeta } from "/app/apps/frontend/src/pages/checkout/cancel.vue?macro=true";
import { default as ticket5ymzKWvpoQgo00TwEyYgmmd6R5w4cLP8ncpJT6_vxZwMeta } from "/app/apps/frontend/src/pages/checkout/ticket.vue?macro=true";
import { default as indexYC2akBHAof4YAtk9sP8hFMkH4Ud2mPyZ_45kYx4GoEy_sMeta } from "/app/apps/frontend/src/pages/dashboard/index.vue?macro=true";
import { default as _91slug_93ktSMw4H8a1dD2xdYW7CaRuEByRQjLnLxz9T3WEmwx_45YMeta } from "/app/apps/frontend/src/pages/products/[slug].vue?macro=true";
import { default as _91slug_93g7zG0L84rUXWB8B34uaHH5co_45N7pYO7ywZUeWC0AlBYMeta } from "/app/apps/frontend/src/pages/services/[slug].vue?macro=true";
import { default as ticket_45exchangekfpBiktBw5YqdBnsUGSCNwukC8ikJ8aoNQ5d9GuBdn4Meta } from "/app/apps/frontend/src/pages/ticket-exchange.vue?macro=true";
import { default as indexRzaQsDlCAwsmicQL0oJzvYyLjL4dIX3bYmopccYRsAgMeta } from "/app/apps/frontend/src/pages/categories/index.vue?macro=true";
import { default as successcdgE8rLkLyPlemVKj2Hi1jxpSb5XkjGA7tS5LlWGDn4Meta } from "/app/apps/frontend/src/pages/checkout/success.vue?macro=true";
import { default as _91slug_93rMFoaM1qVydUN0gpsAFPE7pcQLTlCBSfcVPo6zFfFA4Meta } from "/app/apps/frontend/src/pages/categories/[slug].vue?macro=true";
export default [
  {
    name: "map",
    path: "/map",
    component: () => import("/app/apps/frontend/src/pages/map.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/app/apps/frontend/src/pages/cart.vue")
  },
  {
    name: "menu",
    path: "/menu",
    component: () => import("/app/apps/frontend/src/pages/menu.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: abouteN_n_ImgL9s9ry7JGwbEXWy_7prkd40FO49cE_45MlNxQMeta || {},
    component: () => import("/app/apps/frontend/src/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/frontend/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/apps/frontend/src/pages/contact.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/app/apps/frontend/src/pages/gallery.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/app/apps/frontend/src/pages/reviews.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: { ...(loginvWOTq9B41qLizNvXFXJM2IIpJKAEc_zBQ3omUtKRl0wMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/app/apps/frontend/src/pages/auth/login.vue")
  },
  {
    name: "posts",
    path: "/posts",
    meta: indexaB4vPfpiZWIjhVPsZ_oY2T7FIXkDKKe8Q5JeJnDGphIMeta || {},
    component: () => import("/app/apps/frontend/src/pages/posts/index.vue")
  },
  {
    name: "tags-slug",
    path: "/tags/:slug()",
    meta: _91slug_930_uG6kn_45_451QnAyGMi_45IwozrLWISoLaq79aBswunNVFoMeta || {},
    component: () => import("/app/apps/frontend/src/pages/tags/[slug].vue")
  },
  {
    name: "order-refund",
    path: "/order-refund",
    component: () => import("/app/apps/frontend/src/pages/order-refund.vue")
  },
  {
    name: "order-ticket",
    path: "/order-ticket",
    component: () => import("/app/apps/frontend/src/pages/order-ticket.vue")
  },
  {
    name: "posts-slug",
    path: "/posts/:slug()",
    meta: _91slug_93I1csEqzDIeqWSj1I9RARX__Rl444wNPqaug54MIALoQMeta || {},
    component: () => import("/app/apps/frontend/src/pages/posts/[slug].vue")
  },
  {
    name: "test-session",
    path: "/test-session",
    component: () => import("/app/apps/frontend/src/pages/test-session.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerLKye_WId_LmWOpbjuuKwZm6fkZhhuZ9B6Ys86c2R0v8Meta || {},
    component: () => import("/app/apps/frontend/src/pages/auth/register.vue")
  },
  {
    name: "tickets",
    path: "/tickets",
    meta: indexc7uOu6zZq3xirPceIgHzgkFrtSkfzzLEZ_2xaYkRObEMeta || {},
    component: () => import("/app/apps/frontend/src/pages/tickets/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/app/apps/frontend/src/pages/checkout/index.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indexNKnoxnN0dwRFKLl_2KWz0JMKcrrPgYVpr0LB83VEowkMeta || {},
    component: () => import("/app/apps/frontend/src/pages/products/index.vue")
  },
  {
    name: "services",
    path: "/services",
    meta: index4EqZTS9I4aKnvikjK9CIv7Yi1BHIwqL8HsOKSuV0m5YMeta || {},
    component: () => import("/app/apps/frontend/src/pages/services/index.vue")
  },
  {
    name: "ticket-pricing",
    path: "/ticket-pricing",
    component: () => import("/app/apps/frontend/src/pages/ticket-pricing.vue")
  },
  {
    name: "tickets-slug",
    path: "/tickets/:slug()",
    meta: _91slug_93MAjsfTWQfNZyMxqLPYxwtJFJCDaukJzGfIbp58cLcgQMeta || {},
    component: () => import("/app/apps/frontend/src/pages/tickets/[slug].vue")
  },
  {
    name: "checkout-cancel",
    path: "/checkout/cancel",
    component: () => import("/app/apps/frontend/src/pages/checkout/cancel.vue")
  },
  {
    name: "checkout-ticket",
    path: "/checkout/ticket",
    component: () => import("/app/apps/frontend/src/pages/checkout/ticket.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexYC2akBHAof4YAtk9sP8hFMkH4Ud2mPyZ_45kYx4GoEy_sMeta || {},
    component: () => import("/app/apps/frontend/src/pages/dashboard/index.vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug()",
    meta: _91slug_93ktSMw4H8a1dD2xdYW7CaRuEByRQjLnLxz9T3WEmwx_45YMeta || {},
    component: () => import("/app/apps/frontend/src/pages/products/[slug].vue")
  },
  {
    name: "services-slug",
    path: "/services/:slug()",
    meta: _91slug_93g7zG0L84rUXWB8B34uaHH5co_45N7pYO7ywZUeWC0AlBYMeta || {},
    component: () => import("/app/apps/frontend/src/pages/services/[slug].vue")
  },
  {
    name: "ticket-exchange",
    path: "/ticket-exchange",
    component: () => import("/app/apps/frontend/src/pages/ticket-exchange.vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: indexRzaQsDlCAwsmicQL0oJzvYyLjL4dIX3bYmopccYRsAgMeta || {},
    component: () => import("/app/apps/frontend/src/pages/categories/index.vue")
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    component: () => import("/app/apps/frontend/src/pages/checkout/success.vue")
  },
  {
    name: "categories-slug",
    path: "/categories/:slug()",
    meta: _91slug_93rMFoaM1qVydUN0gpsAFPE7pcQLTlCBSfcVPo6zFfFA4Meta || {},
    component: () => import("/app/apps/frontend/src/pages/categories/[slug].vue")
  },
  {
    name: "bai-viet",
    path: "/bai-viet",
    component: () => import("/app/apps/frontend/src/pages/posts/index.vue")
  },
  {
    name: "bai-viet-chi-tiet",
    path: "/bai-viet/:slug",
    meta: _91slug_93I1csEqzDIeqWSj1I9RARX__Rl444wNPqaug54MIALoQMeta || {},
    component: () => import("/app/apps/frontend/src/pages/posts/[slug].vue")
  },
  {
    name: "san-pham",
    path: "/san-pham",
    component: () => import("/app/apps/frontend/src/pages/products/index.vue")
  },
  {
    name: "san-pham-chi-tiet",
    path: "/san-pham/:slug",
    meta: _91slug_93ktSMw4H8a1dD2xdYW7CaRuEByRQjLnLxz9T3WEmwx_45YMeta || {},
    component: () => import("/app/apps/frontend/src/pages/products/[slug].vue")
  },
  {
    name: "dich-vu",
    path: "/dich-vu",
    component: () => import("/app/apps/frontend/src/pages/services/index.vue")
  },
  {
    name: "dich-vu-chi-tiet",
    path: "/dich-vu/:slug",
    meta: _91slug_93g7zG0L84rUXWB8B34uaHH5co_45N7pYO7ywZUeWC0AlBYMeta || {},
    component: () => import("/app/apps/frontend/src/pages/services/[slug].vue")
  },
  {
    name: "danh-muc-san-pham",
    path: "/danh-muc-san-pham",
    component: () => import("/app/apps/frontend/src/pages/categories/index.vue")
  },
  {
    name: "danh-muc-san-pham-chi-tiet",
    path: "/danh-muc-san-pham/:slug",
    meta: _91slug_93rMFoaM1qVydUN0gpsAFPE7pcQLTlCBSfcVPo6zFfFA4Meta || {},
    component: () => import("/app/apps/frontend/src/pages/categories/[slug].vue")
  },
  {
    name: "lien-he",
    path: "/lien-he",
    component: () => import("/app/apps/frontend/src/pages/contact.vue")
  },
  {
    name: "thu-vien-hinh-anh",
    path: "/thu-vien-hinh-anh",
    component: () => import("/app/apps/frontend/src/pages/gallery.vue")
  },
  {
    name: "gioi-thieu",
    path: "/gioi-thieu",
    component: () => import("/app/apps/frontend/src/pages/about.vue")
  },
  {
    name: "bang-gia-ve",
    path: "/bang-gia-ve",
    component: () => import("/app/apps/frontend/src/pages/ticket-pricing.vue")
  },
  {
    name: "thuc-don",
    path: "/thuc-don",
    component: () => import("/app/apps/frontend/src/pages/menu.vue")
  },
  {
    name: "dat-ve",
    path: "/dat-ve",
    component: () => import("/app/apps/frontend/src/pages/order-ticket.vue")
  }
]